import type { InputHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

export interface ToggleProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "type"
> {
  label: string;
  description?: string;
}

export function Toggle({ className, description, label, ...props }: ToggleProps) {
  return (
    <label
      className={twMerge(
        "flex min-h-14 cursor-pointer items-center justify-between gap-4 rounded-lg border border-line bg-surface/70 px-4 py-3 transition hover:border-accent/40 hover:bg-accent/5",
        className
      )}
    >
      <span>
        <span className="block text-sm font-semibold text-ink">{label}</span>
        {description && (
          <span className="mt-0.5 block text-xs leading-relaxed text-muted">
            {description}
          </span>
        )}
      </span>
      <span className="relative shrink-0">
        <input className="peer sr-only" type="checkbox" {...props} />
        <span className="block h-6 w-11 rounded-full bg-line shadow-inner transition peer-checked:bg-accent peer-focus-visible:ring-2 peer-focus-visible:ring-accent peer-focus-visible:ring-offset-2 peer-disabled:opacity-50" />
        <span className="absolute left-1 top-1 h-4 w-4 rounded-full bg-white shadow-sm transition-transform peer-checked:translate-x-5" />
      </span>
    </label>
  );
}
